import { FormErrors } from '@openx/components-core/lib/FormErrors/FormErrors.tsx';

import type { LalSegmentFormState } from '@openx/types/segments.ts';
import { useCallback, useState } from 'react';
import { useLocation } from 'react-router';
import { useInitialValues } from '../hooks/useInitialValues.ts';
import { useSegmentContext } from '../utils/context/SegmentContext.tsx';
import { mapFormStateToCreateLookalike } from '../utils/mapFormState.ts';
import { LalSegmentsForm } from './LalSegmentsForm.tsx';

export type LalSegmentCreateFormProps = {
  goBack: () => void;
  accountUid: string;
};

export const LalSegmentCreateForm = ({ goBack, accountUid }: LalSegmentCreateFormProps) => {
  const { useCreateLookalikeSegment } = useSegmentContext();
  const { createLookalikeSegment, isCreating } = useCreateLookalikeSegment();

  const [submitErrors] = useState<string[]>([]);
  const [selectedAccountId, setSelectedAccountId] = useState(accountUid);

  const { state } = useLocation();
  const segments = state?.segments ?? [];

  const accountId = segments[0]?.account?.id ?? selectedAccountId;

  const initialValues = useInitialValues(accountId);

  const onCancel = useCallback(() => {
    goBack();
  }, [goBack]);

  const onSubmit = useCallback(
    (values: LalSegmentFormState) => {
      const mappedValues = mapFormStateToCreateLookalike(values);
      createLookalikeSegment(mappedValues);
    },
    [createLookalikeSegment]
  );

  return (
    <>
      <FormErrors errors={submitErrors} />
      <LalSegmentsForm
        goBack={onCancel}
        initialValues={initialValues}
        onSubmit={onSubmit}
        isSubmitting={isCreating}
        setSelectedAccountId={setSelectedAccountId}
      />
    </>
  );
};
